export default __webpack_public_path__ + "static/Content-Hover-80925299967c65d1da2cafbeced45f37.svg";